module.exports = __webpack_public_path__ + "static/img/Updates version 2.1.0.e23013b.png";